import { useMemo } from 'react';
import { useLiveRxQuery } from 'rxdb/plugins/react';
import { useStableQuery } from '../../db/useStableQuery';
import type { ProjectDocType } from '@ast-data/shared';
import { familyProjectIds } from './family';

/**
 * The project ids that share data with `projectId` — its Teilmaßnahme family
 * (always including itself; a standalone project resolves to just itself). Used
 * to widen the parcel pickers, cross-references and duplicate detection, while
 * a project's own content lists stay project-scoped.
 */
export function useFamilyProjectIds(projectId: string): string[] {
    const projectsQuery = useStableQuery<ProjectDocType>({});
    const { results: projectsDocs } = useLiveRxQuery<ProjectDocType>({
        collection: 'projects',
        query: projectsQuery
    });
    const projects = useMemo(
        () => projectsDocs.map((doc) => doc.toMutableJSON() as ProjectDocType),
        [projectsDocs]
    );
    return useMemo(() => {
        const self = projects.find((project) => project.id === projectId);
        return familyProjectIds(projects, self?.familyId ?? '', projectId);
    }, [projects, projectId]);
}
